import React from 'react'
import Table from '../Assets/table';
import ButtonComponent from './atoms/button.atoms';

const Bar = () => {
    return (
      <div className="md:ml-6 my-6 mt-40 flex flex-col md:flex-row items-center justify-between flex-wrap  px-4">
        {/* bar container  */}

        {/* bar left */}
        <div
          style={{
            opacity: " 1",
            transform: " translate(0px, 0px)",
            visibility: "inherit",
          }}
          className='w-full md:w-1/2 mb-10 md:mb-0'
          // className=" flex-[50%] flex-wrap flex-col top-40 "
        >
          <h2 className=" text-[#082552] font-semibold leading-none mb-1 tracking-tighter text-[3rem] sm:text-[4rem] md:text-[6rem] text-center md:text-left">
            {" "}
            Get a <span className=" italic font-[200] ">little</span>
            &nbsp;
            <br /> <span className="block md:inline ">richer each day</span>
          </h2>
          <h5
            className="mb-20 tracking-tight text-center md:text-left mt-6 text-[1.2rem]  sm:text-[1.5rem] md:text-[2rem]   font-medium text-[#082552] "
            style={{
              opacity: " 1",
              transform: " translate(0px, 0px)",
              visibility: "inherit",
            }}
          >
            One small step today, a giant leap for tomorrow.
          </h5>
          {/*  */}
               <a href="https://cwry.se/app" className=" ">
            <ButtonComponent alt children="Start your financial journey" />{" "}
          </a>
          {/*
           */}
        </div>

        {/* bar right ml-6 my-6  grid grid-cols-2 gap-8*/}
         <div className="hidden relative flex-[50%] h-full overflow-hidden">
          <div className="relative top-20 h-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1270 1360"
              width="870"
              height="660"
              preserveAspectRatio="xMidYMid meet"
              style={{
                overflow: "hidden",
                width:
                  "100%; height: 100%; transform: translate3d(0px, 0px, 0px);",
              }}
            >
              <defs>
                <clipPath id="__lottie_element_2">
                  <rect width="1270" height="1360" x="0" y="0"></rect>
                </clipPath>
              </defs>
              <g clip-path="url(#__lottie_element_2)">
                <g
                  transform="matrix(1.2899999618530273,0,0,1,1.9583740234375,1128.6500244140625)"
                  opacity="1"
                  style={{ display: "block" }}
                >
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,199.46499633789062,115.19400024414062)"
                  >
                    <path
                      fill="rgb(0,102,243)"
                      fill-opacity="1"
                      d=" M198.44000244140625,-477.52099609375 C198.44000244140625,-477.52099609375 0.6470000147819519,-362.5769958496094 0.6470000147819519,-362.5769958496094 C0.6470000147819519,-362.5769958496094 -198.43899536132812,-477.5190124511719 -198.43899536132812,-477.5190124511719 C-198.43899536132812,-477.5190124511719 -0.6470000147819519,-592.4639892578125 -0.6470000147819519,-592.4639892578125 C-0.6470000147819519,-592.4639892578125 198.44000244140625,-477.52099609375 198.44000244140625,-477.52099609375z"
                    ></path>
                  </g>
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,298.78399658203125,252.02200317382812)"
                  >
                    <path
                      fill="rgb(8,37,82)"
                      fill-opacity="1"
                      d=" M-98.6709976196289,-499.4049987792969 C-98.6709976196289,-499.4049987792969 -99.12200164794922,-15.977999687194824 -99.12200164794922,-15.977999687194824 C-99.12200164794922,-15.977999687194824 -33.29899978637695,-15.977999687194824 -33.29899978637695,-15.977999687194824 C-33.29899978637695,-15.977999687194824 98.34600067138672,-15.979999542236328 98.34600067138672,-15.979999542236328 C98.34600067138672,-15.979999542236328 99.12200164794922,-614.3489990234375 99.12200164794922,-614.3489990234375 C99.12200164794922,-614.3489990234375 -98.6709976196289,-499.4049987792969 -98.6709976196289,-499.4049987792969z"
                    ></path>
                  </g>
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,100.18099975585938,252.02200317382812)"
                  >
                    <path
                      fill="rgb(0,41,233)"
                      fill-opacity="1"
                      d=" M-99.93099975585938,-15.977999687194824 C-99.93099975585938,-15.977999687194824 99.48100280761719,-15.977999687194824 99.48100280761719,-15.977999687194824 C99.48100280761719,-15.977999687194824 99.93099975585938,-499.4049987792969 99.93099975585938,-499.4049987792969 C99.93099975585938,-499.4049987792969 -99.15499877929688,-614.3480224609375 -99.15499877929688,-614.3480224609375 C-99.15499877929688,-614.3480224609375 -99.93099975585938,-15.977999687194824 -99.93099975585938,-15.977999687194824z"
                    ></path>
                  </g>
                </g>
                <g
                  transform="matrix(1.2899999618530273,0,0,1,377.6028747558594,788.6500244140625)"
                  opacity="1"
                  style={{ display: "block" }}
                >
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,200.4290008544922,115.19400024414062)"
                  >
                    <path
                      fill="rgb(0,102,243)"
                      fill-opacity="1"
                      d=" M198.44000244140625,-477.52099609375 C198.44000244140625,-477.52099609375 0.6470000147819519,-362.5769958496094 0.6470000147819519,-362.5769958496094 C0.6470000147819519,-362.5769958496094 -198.44000244140625,-477.5190124511719 -198.44000244140625,-477.5190124511719 C-198.44000244140625,-477.5190124511719 -0.6470000147819519,-592.4639892578125 -0.6470000147819519,-592.4639892578125 C-0.6470000147819519,-592.4639892578125 198.44000244140625,-477.52099609375 198.44000244140625,-477.52099609375z"
                    ></path>
                  </g>
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,299.2650146484375,422.0220031738281)"
                  >
                    <path
                      fill="rgb(8,37,82)"
                      fill-opacity="1"
                      d=" M-98.18900299072266,-669.4039916992188 C-98.18900299072266,-669.4039916992188 -99.60299682617188,154.01800537109375 -99.60299682617188,154.01800537109375 C-99.60299682617188,154.01800537109375 97.86299896240234,154.02099609375 97.86299896240234,154.02099609375 C97.86299896240234,154.02099609375 99.60299682617188,-784.3480224609375 99.60299682617188,-784.3480224609375 C99.60299682617188,-784.3480224609375 -98.18900299072266,-669.4039916992188 -98.18900299072266,-669.4039916992188z"
                    ></path>
                  </g>
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,100.66300201416016,422.02301025390625)"
                  >
                    <path
                      fill="rgb(0,41,233)"
                      fill-opacity="1"
                      d=" M-100.41300201416016,154.02099609375 C-100.41300201416016,154.02099609375 98.9990005493164,154.02099609375 98.9990005493164,154.02099609375 C98.9990005493164,154.02099609375 100.41300201416016,-669.405029296875 100.41300201416016,-669.405029296875 C100.41300201416016,-669.405029296875 -98.6729965209961,-784.3480224609375 -98.6729965209961,-784.3480224609375 C-98.6729965209961,-784.3480224609375 -100.41300201416016,154.02099609375 -100.41300201416016,154.02099609375z"
                    ></path>
                  </g>
                </g>
                <g
                  transform="matrix(1.2899999618530273,0,0,1,752.214111328125,448.6500244140625)"
                  opacity="1"
                  style={{ display: "block" }}
                >
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,201.42100524902344,115.19400024414062)"
                  >
                    <path
                      fill="rgb(0,102,243)"
                      fill-opacity="1"
                      d=" M198.43899536132812,-432.52099609375 C198.43899536132812,-432.52099609375 0.6470000147819519,-317.5769958496094 0.6470000147819519,-317.5769958496094 C0.6470000147819519,-317.5769958496094 -198.44000244140625,-432.5190124511719 -198.44000244140625,-432.5190124511719 C-198.44000244140625,-432.5190124511719 -0.6470000147819519,-547.4639892578125 -0.6470000147819519,-547.4639892578125 C-0.6470000147819519,-547.4639892578125 198.43899536132812,-432.52099609375 198.43899536132812,-432.52099609375z"
                    ></path>
                  </g>
                  {/* <g
                    opacity="1"
                    transform="matrix(1,0,0,1,299.5780029296875,597.02197265625)"
                  > */}
                  {/* <path
                      fill="rgb(8,37,82)"
                      fill-opacity="1"
                      d=" M-97.51000213623047,-799.405029296875 C-97.51000213623047,-799.405029296875 -100.28299713134766,319.47198486328125 -100.28299713134766,319.47198486328125 C-100.28299713134766,319.47198486328125 97.5510025024414,319.47198486328125 97.5510025024414,319.47198486328125 C97.5510025024414,319.47198486328125 100.28299713134766,-914.3489990234375 100.28299713134766,-914.3489990234375 C100.28299713134766,-914.3489990234375 -97.51000213623047,-799.405029296875 -97.51000213623047,-799.405029296875z"
                    ></path> */}
                  {/* </g> */}
                  <g
                    opacity="1"
                    transform="matrix(1,0,0,1,101.15899658203125,597.0230102539062)"
                  >
                    <path
                      fill="rgb(0,41,233)"
                      fill-opacity="1"
                      d=" M-100.90899658203125,319.468994140625 C-100.90899658203125,319.468994140625 98.50299835205078,319.4700012207031 98.50299835205078,319.4700012207031 C98.50299835205078,319.4700012207031 100.90899658203125,-799.406005859375 100.90899658203125,-799.406005859375 C100.90899658203125,-799.406005859375 -98.177001953125,-914.3480224609375 -98.177001953125,-914.3480224609375 C-98.177001953125,-914.3480224609375 -100.90899658203125,319.468994140625 -100.90899658203125,319.468994140625z"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          </div>
        

        {/* {each box} */}
          <div className="hidden absolute -mb-[698px] -bottom-84 ml-48 left-46">
              {/*  */}

                <main className="relative mr-48 left-40 mb-18 bottom-60">
                    <div
                      className=" absolute z-20 left-1/3"
                      style={{
                        opacity: 1,
                        visibility: "inherit",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      {/*  */}
                      <div className="flex relative w-full z-1 mr-14 -right-36 space-x-4 items-start flex-row">
                        <div className=" flex flex-col -bottom-40 rounded-xl bg-[white] w-72 px-[16px] py-[24px] border border-solid border-[rgba(8,37,82,.07)] shadow-[1px_3px_4px_rgba(8,37,82,.04)]">
                          <h6 className="font-semibold text-[#082552] ">
                            Build your savings
                          </h6>
                          <p
                            className="text-[#6c82a3] font-[400] mt-[8px] 
                      text-[.8rem]  "
                          >
                            Consistently automate your savings while setting realistic
                            goals.
                          </p>
                        </div>
                        <div className="rounded-full text-center items-center bg-white text-[#082552] h-[40px] w-[40px] text-[1.6rem]">
                          1
                        </div>
                      </div>
                    </div>
                </main>
            

                <main className="relative ml-[494px] right-82 bottom-24">
                  {" "}
                  <div
                    className="absolute z-20 bottom-1/3 -right-18 "
                    style={{
                      opacity: 1,
                      visibility: "inherit",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <div className="flex mt-4 relative justify-between -top-48 right-6 space-x-4 items-start flex-row">
                      <div
                        className=" flex flex-col rounded-xl
                    bg-white bottom-3 w-72 px-[16px] py-[24px] border border-solid border-[rgba(8,37,82,.07)] shadow-[1px_3px_4px_rgba(8,37,82,.04)]"
                      >
                        <h6 className="font-semibold text-[#082552] ">
                          Invest deliberately
                        </h6>
                        <p
                          className="text-[#6c82a3] font-[400] mt-[8px] 
                      text-[.8rem]  "
                        >
                          Invest in our diverse range of assets that grow in value over
                          time.
                        </p>
                      </div>
                      <div
                        className="rounded-full text-center items-center 
                    bg-white text-[#082552] h-[40px] w-[40px] text-[1.6rem]"
                      >
                        2
                      </div>
                    </div>
                  </div>
                </main>

                <main className="relative -mr-[454px] bottom-96 right-50">
                  <div className="absolute z-20 right-16 mr-4 bottom-3 ">
                    <div
                      className="flex relative justify-between bottom-12 left-16 space-x-4 items-start flex-row"
                      style={{
                        opacity: 1,
                        visibility: "inherit",
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <div
                        className="flex -top-68 right-8 flex-col rounded-xl
                    bg-white bottom-3 w-72 px-[16px] py-[24px] border border-solid border-[rgba(8,37,82,.07)] shadow-[1px_3px_4px_rgba(8,37,82,.04)]"
                      >
                        <h6 className="font-semibold text-[#082552] ">Stay rich ✨</h6>
                        <p
                          className="text-[#6c82a3] font-[400] mt-[8px] 
                      text-[.8rem]  "
                        >
                          Protect your wealth by managing risk, seeking advice and
                          making smart financial decisions.
                        </p>
                      </div>
                      {/* <div
                        className="rounded-full text-center items-center 
                    bg-white text-[#082552] h-[40px] w-[40px] text-[1.6rem]"
                      >
                        3
                      </div> */}
                    </div>
                  </div>
                </main>
          </div> 
        {/*  */}

      </div>
    );
}

export default Bar